export const templateList = 'templateList';
export const templateIndustriesListKey = 'templateIndustriesListKey';
export const companiesListKey = 'companiesListKey';
export const tagsListKey = 'tagsListKey';
export const companiesAssignedListKey = 'companiesAssignedListKey';

export const hireflixTemplateQuestions = [
  {
    id: 1,
    title: 'Personality, communication, and culture alignment',
    description:
      'Tell us a little about yourself — what kind of work environment do you enjoy most, and what motivates you on the job?',
  },
  {
    id: 2,
    title: 'Preparation, intent, and basic understanding of our brand',
    description: 'Why do you want to work here (or in this role)?',
  },
  {
    id: 3,
    title: 'Real-world experience and soft skills',
    description:
      'Describe a time you provided great customer service or helped solve a problem for a guest/team member.',
  },
  {
    id: 4,
    title: 'Responsibility and attendance reliability',
    description:
      'Our team relies heavily on dependability. What does being reliable mean to you, and how do you show it?',
  },
  {
    id: 5,
    title: 'Measures initiative and coachability',
    description:
      'If you were hired, what would you be most excited to learn or improve at in your first 30 days?',
  },
];
